import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import { couponListPlaceHolderData } from '~/utils/placeholderData'

export default (payload) => {
    const { centerRoute, shopUid = null, oid = null, bearerToken = null } = payload

    const authStore = useAuthStore()
    const { isLoggedIn } = storeToRefs(authStore)

    const queryKey = computed(() => {
        const route = centerRoute || ''
        const shop = shopUid || ''
        const loggedStatus = isLoggedIn.value ? oid.value : 'loggedOut'
        return [shop ? 'shopCouponList' : 'couponList', shop || route, loggedStatus]
    })

    const fetchCoupons = () => {
        const shopCouponsApi = `/api/consumers/coupons?centerUid=${centerRoute}&shopUid=${shopUid}`
        const centerCouponsApi = `/api/consumers/coupons?centerUid=${centerRoute}`
        const userShopCouponListApi = `/api/consumers/profiles/getCoupons?centerUid=${centerRoute}&shopUid=${shopUid}`
        const userCenterCouponListApi = `/api/consumers/profiles/getCoupons?centerUid=${centerRoute}`

        const apiUrl = isLoggedIn.value
            ? (shopUid ? userShopCouponListApi : userCenterCouponListApi)
            : (shopUid ? shopCouponsApi : centerCouponsApi)

        const headers = isLoggedIn.value
            ? {
                    'Authorization': `Bearer ${bearerToken.value}`,
                    'User-Oid': oid.value
                }
            : {}

        return $fetch(apiUrl, { headers })
    }

    return useFetchWithTanstackQuery({
        queryKey: queryKey.value,
        queryFn: fetchCoupons,
        options: {
            staleTime: 60 * 60 * 1000, // 1 hour
            placeholderData: couponListPlaceHolderData,
            enabled: isLoggedIn.value ? isLoggedIn.value : true
        }
    })
}
